import httpClient from "../../api/httpClient";
import { createWrappedAsyncThunk } from "../createWrappedAsyncThunk";

export const getPostersByTenantId = createWrappedAsyncThunk(
  "posters/getPostersByTenantId",
  async ({ tenant_id }) => {
    const { data } = await httpClient.get(`posters`, {
      params: {
        tenant_id,
      },
    });
    return { tenant_id, data };
  },
);

export const savePoster = createWrappedAsyncThunk(
  "posters/savePoster",
  async ({ isClone, ...payload }) => {
    return await httpClient.post(
      isClone ? "posters/clone" : `posters`,
      payload,
    );
  },
);

export const deletePoster = createWrappedAsyncThunk(
  "posters/deletePoster",
  async (payload) => {
    return await httpClient.delete(`posters`, {
      data: payload,
    });
  },
);

export const updatePosterKey = createWrappedAsyncThunk(
  "posters/updatePosterKey",
  async ({ poster_id }) => {
    return await httpClient.post(`update-file-key`, {
      poster_id,
    });
  },
);
